import { setLocal, clearLocal } from '@/utils/local';
import { defineStore } from 'pinia';
import { v4 as uuidv4 } from 'uuid'; // 需要安装uuid库
import { setToken, getToken } from '@/api/customize';
import router from '@/router';
import { Message } from 'view-ui-plus';

export const useUserStore = defineStore(
  'useUserStore',
  () => {
    const userId = ref('');
    const userSuper = ref('');
    const EXPIRE_TIME = ref(12 * 60 * 60 * 1000);

    const reset = () => {
      userId.value = '';
      userSuper.value = '';
      clearLocal();
    };
    const changeUserId = (val) => {
      userId.value = val;
      setLocal('userId', val);
      if (val) {
        setToken(new Date().getTime() + '');
      }
    };
    const changeUserSuper = (val) => {
      userSuper.value = val;
      setLocal('userSuper', val);
    };
    //判断是否过期
    const expireToken = async () => {
      const currentTime = new Date().getTime();
      if (currentTime - getToken() > EXPIRE_TIME.value) {
        Message.error('登录过期，请重新登录！');
        reset();
        router.replace('/');
        return Promise.reject({});
      } else {
        return Promise.resolve({});
      }
    };

    return {
      userId,
      userSuper,
      EXPIRE_TIME,
      reset,
      changeUserId,
      changeUserSuper,
      expireToken,
    };
  },
  {
    persist: {
      pick: ['userId', 'userSuper'],
      key: 'useUserStore',
      storage: localStorage,
    },
  }
);
